import {ReactNode, FC} from 'react';

import {PageFilter} from 'filters/types';

export enum FilterTopbarItemId {
  AddFilters = 'addFilters',
  FiltersDropdown = 'filtersDropdown',
  ActivityCodes = 'activityCodes',
  PremiumType = 'premiumType',
  DateRange = 'dateRange',
  AdditionalDateRange = 'additionalDateRange',
  DatasourceType = 'datasourceType',
  PolicyStatusType = 'policyStatusType',
  PolicyStatus = 'policyStatus',
  ExpandMetrics = 'expandMetrics',
  ExpandChart = 'expandChart',
  PolicyStatusCode = 'policyStatusCode',
  DepartmentLevel = 'departmentLevel',
  Departments = 'departments',
  Employees = 'employees',
  MarketIcoBcoToggle = 'marketIcoBcoToggle',
  MarketPlacement = 'marketPlacement',
  CarrierLevel = 'carrierLevel',
  ConfidenceScore = 'confidenceScore',
  CarrierType = 'carrierType',
  Carrier = 'carrier',
  RenewalsDateRange = 'renewalsDateRange',
  Intermediary = 'intermediarie',
  States = 'states',
  Products = 'products',
  Industries = 'industries',
  Producer = 'producer',
  ProducerAmsCodes = 'producerAMSCodes',
  AccountManager = 'accountManager',
  AccountManagerAmsCodes = 'accountManagerAMSCodes',
  AccountExecutive = 'accountExecutive',
  AccountExecutiveAmsCodes = 'accountExecutiveAMSCodes',
  ClientTag = 'clientTag',
  PolicyTag = 'policyTag',
  PolicySource = 'policySource',
  AgencyCode = 'agencyCode',
  SettingsUsers = 'settingsUsers',
  SettingsRoles = 'settingsRoles',
  SettingsPermissions = 'settingsPermissions',
  SettingsUserEnvironments = 'settingsUserEnvironments',
}

type TopbarBasicFields = {
  id: FilterTopbarItemId;
  onClick?: () => void;
  onReset?: (filter: PageFilter) => PageFilter;
};

export type CustomTopbarItem<V> = {
  id: FilterTopbarItemId;
  Component: FC<Omit<CustomTopbarItem<V>, 'Component'>>;
  getValue: (filter: PageFilter | undefined) => V;
  onApply: (filter: PageFilter, value: V) => PageFilter;
};

export type AddFiltersItemConfig = TopbarBasicFields & {
  type: 'add-filters';
};

export type FiltersDropdownItemConfig = TopbarBasicFields & {
  type: 'filters-dropdown';
};

export type ValueItemConfig<V> = TopbarBasicFields & {
  type: 'value';
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
  getValue: (filter: PageFilter | undefined) => V;
  getTooltip?: (filter: PageFilter | undefined, value: V) => ReactNode;
};

export type CounterItemConfig<V> = TopbarBasicFields & {
  type: 'counter';
  disabled?: boolean;
  entity: string;
  variant?: 'primary' | 'secondary';
  getCount: (filter: PageFilter | undefined) => V;
  getTooltip?: (filter: PageFilter | undefined, count: V) => ReactNode;
};

export type DataCounterItemConfig<V, O extends {skip?: boolean}, D> = TopbarBasicFields & {
  type: 'data-counter';
  disabled?: boolean;
  entity: string;
  variant?: 'primary' | 'secondary';
  useData: (options: O) => {data: D; loading: boolean};
  getDataOptions: (filter: PageFilter | undefined) => O;
  getCount: (filter: PageFilter | undefined, data: D | undefined) => V;
  // getTooltip?: (filter: PageFilter | undefined, count: V) => ReactNode;
};

export type RadioGroupItemConfig<V> = {
  id: FilterTopbarItemId;
  type: 'radio-group';
  variant?: 'primary' | 'secondary';
  getValue: (filter: PageFilter | undefined) => V;
  getLabel: (value: V) => ReactNode;
  dropdownLabel: string;
  options: {value: V; label: ReactNode}[];
  onApply: (filter: PageFilter, value: V) => PageFilter;
};

export type FilterTopbarItem =
  | CustomTopbarItem<any>
  | AddFiltersItemConfig
  | FiltersDropdownItemConfig
  | ValueItemConfig<any>
  | CounterItemConfig<any>
  | DataCounterItemConfig<any, any, any>
  | RadioGroupItemConfig<any>;
